<ng-container *ngIf="model && model.view && layoutMode !== 'gallery'">
  <div
    [id]="'result-item-' + resultsIndex"
    #element
    class="results-item"
    [class.blur]="confirmOptions"
    [class.clickable]="isClickable"
    [class.hovered]="hovered"
    [class.show-link-indication]="showResultSections.showLinkIndication"
    tabindex="-1"
    [dragAndDrop]="dragData"
    data-cy="search-results-item"
  >
    <div class="result-item-container">
      <div class="result-item-content-container">
        <link-indicator
          class="link-indicator"
          *ngIf="showResultSections?.showLinkIndicator && model.linkIndicator"
          [name]="model.link?.name"
          [color]="model.link?.color"
          [isRestricted]="model.link?.shareOptions?.restricted"
        ></link-indicator>
        <div class="search-results-icon" data-cy="search-results-icon">
          <ng-container *ngIf="isIconOverlayEmoji; else noEmoji">
            <u-icon iconCtx="url" class="result-icon-logo no-drag" [model]="iconModel" [styles]="{ backgroundSize: 'contain' }"></u-icon>
          </ng-container>
          <ng-template #noEmoji>
            <u-icon *ngIf="model.view?.icon" class="result-icon-logo no-drag" (error)="onIconError($event)" [model]="iconModel"></u-icon>
            <u-icon
              *ngIf="model.view?.iconOverlay"
              iconCtx="style"
              class="result-icon-overlay no-drag"
              [model]="iconOverlayModel"
              [styles]="{ backgroundSize: 'contain' }"
            ></u-icon>
          </ng-template>
        </div>
        <div class="main" [class.one-line]="isShowSingleLineView" #main>
          <ng-container *ngIf="model?.showResultSections?.showInputTitle || showResultSections?.showInputTitle">
            <input-title
              [text]="model.view.title.text"
              [inputPlaceholder]="model.view.title.text"
              [defaultInputModel]="model.view.title.text"
              [inputModel]="model.view.title.text"
              (onDisplayInput)="focusOnInput($event)"
              (onBlurUInput)="onBlurUInput($event)"
              (outsideClick)="onEditTitleClickOut()"
            >
            </input-title>
          </ng-container>

          <div
            class="title-container"
            [class.one-line]="isShowSingleLineView"
            *ngIf="model.view && !model?.showResultSections?.showInputTitle && !showResultSections?.showInputTitle"
            [class.with-subtitle]="model.view.subtitle && !showResultSections.showSubtitleInSecondLine && !isShowSingleLineView"
            [class.with-badge]="model.view.badge"
            [class.subtitle-end-line]="showResultSections.showSubtitleInEndLine"
            [class.trim-content]="
              !isLauncher &&
              !isShowSingleLineView &&
              model.view.subtitle &&
              showResultSections.trimSubtitleLength &&
              !showResultSections.showSubtitleInSecondLine
            "
          >
            <div class="title-text">
              <result-title
                [model]="model.action?.type === 'files' ? fileItemTitle?.start : model.view.title"
                [highlights]="highlights"
                [mainWidth]="mainWidth"
                [tooltipPosition]="'right'"
                [showSingleLineView]="isShowSingleLineView || !model.view.subtitle || showResultSections.showSubtitleInSecondLine"
                (contextmenu)="model.view.title.onRightClick ? null : onRightClick($event, 'title')"
                (auxclick)="model.view.title.onRightClick ? null : onAuxClick($event, 'title')"
                (invoke)="
                  onInvoke({
                    command: $event.command,
                    context: makeContext({ appId: model?.resource?.appId, openWith: model.openWith }, $event.context),
                    trigger: $event.trigger,
                    source: $event.source,
                    immediate: $event.immediate,
                  })
                "
                [selected]="selected"
                [dragMetadata]="dragMetadata"
                click-invoker
                #title
              >
                <span
                  *ngIf="model.action?.type === 'files'"
                  [innerHTML]="fileItemTitle?.end | highlight: highlights : highlightStyle"
                ></span>
              </result-title>

              <ng-container
                *ngTemplateOutlet="
                  !isShowSingleLineView && !showResultSections.showSubtitleInSecondLine && !showResultSections.showSubtitleInEndLine
                    ? resultSubtitle
                    : null
                "
              >
              </ng-container>
            </div>

            <div class="title-indicate" data-cy="search-results-indicator">
              <ng-container
                *ngTemplateOutlet="
                  !isShowSingleLineView || (isShowSingleLineView && showResultSections.showSubtitleInEndLine) ? resultBadge : null
                "
              >
              </ng-container>
              <ng-container *ngTemplateOutlet="!isShowSingleLineView ? resultFavorite : null"> </ng-container>
              <div *ngIf="model?.iconIndicate" class="icon-indicate">
                <u-icon [model]="iconIndicateModel" [styles]="{ fontSize: '14px', display: 'flex' }"></u-icon>
              </div>
            </div>

            <ng-container *ngTemplateOutlet="showResultSections.showSubtitleInEndLine ? resultSubtitle : null"> </ng-container>
          </div>

          <ng-container
            *ngTemplateOutlet="
              (isShowSingleLineView || showResultSections.showSubtitleInSecondLine) && !showResultSections.showSubtitleInEndLine
                ? resultSubtitle
                : null
            "
          >
          </ng-container>
          <ng-container
            *ngTemplateOutlet="
              isShowSingleLineView && (!isShowSingleLineView || !showResultSections.showSubtitleInEndLine) ? resultBadge : null
            "
          >
          </ng-container>
          <ng-container *ngTemplateOutlet="isShowSingleLineView ? resultFavorite : null"> </ng-container>

          <ng-container *ngIf="model.view.annotation && showResultSections.showAnnotation">
            <result-annotation
              [model]="model.view.annotation"
              [highlights]="highlights"
              (invoke)="onMouseClick({ command: $event })"
            ></result-annotation>
          </ng-container>

          <ng-container *ngIf="model.snippet && showResultSections.showSnippet && showResultSections.shortSnippet">
            <p
              class="short-snippet"
              [innerHTML]="model.snippet | truncate: SNIPPET_LIMIT - 1 | highlight: highlights : highlightStyle | preHtml"
            ></p>
          </ng-container>

          <div
            class="result-snippet"
            [class.trim-content]="!isLauncher && model.view.snippet && showResultSections.showSnippet && !showResultSections.shortSnippet"
            *ngIf="
              model.view.snippet &&
              showResultSections.showSnippet &&
              !showResultSections.shortSnippet &&
              !showResultSections.showSingleLineView
            "
          >
            <result-snippet
              class="snippet"
              [ngClass]="{ blur: showButtonSnippet && !showFullSnippet, show: showFullSnippet }"
              [model]="model.view.snippet"
              [highlights]="highlights"
              (invoke)="onMouseClick({ command: $event })"
              #snippet
            ></result-snippet>
            @if (showButtonSnippet) {
              <u-button
                class="show-more-button"
                [versionNumber]="2"
                [styleType]="'text'"
                [sizeElement]="'extra-small'"
                [styles]="{ 'padding-left': '0' }"
                [label]="showFullSnippet ? 'Show less' : 'Show more...'"
                (onClick)="onChangeSnippetMode($event)"
              >
              </u-button>
            }
          </div>

          <ng-container *ngIf="model.view.subView && showResultSections.showSubView">
            <result-sub-view [model]="model.view.subView" [highlights]="highlights" (invoke)="onInvoke($event)"></result-sub-view>
          </ng-container>

          <div
            #resultBullets
            class="bullets-container result-line"
            tabindex="-1"
            *ngIf="model.view?.bullets?.length > 0 && !isShowSingleLineView && showResultSections.showBullets"
          >
            <result-bullet
              #resultBullet
              tabindex="-1"
              *ngFor="let bullet of model.view.bullets | slice: 0 : bulletsLimit; index as i"
              [model]="bullet"
              [maxBulletWidth]="maxBulletWidth(i, bulletPartsRef)"
              click-invoker
              [ngStyle]="i === bulletsLimit - 1 ? { 'max-width': lastChildWidth + 'px' } : { 'max-width': '100%' }"
              (invoke)="onMouseClick({ command: $event })"
            >
            </result-bullet>
            <result-bullet
              class="hidden-bullets-counetr"
              *ngIf="model?.view?.bullets?.length - bulletsLimit > 0"
              tabindex="-1"
              [model]="counterBullet"
              click-invoker
              (invoke)="onMouseClick({ command: $event })"
            ></result-bullet>
          </div>

          <div
            data-cy="search-results-tags-container"
            #resultTags
            class="tag-groups result-line"
            tab-index="-1"
            *ngIf="tagGroups?.length > 0 && !isShowSingleLineView && showResultSections.showTags"
          >
            <div class="tag-group" *ngFor="let group of tagGroups | slice: 0 : tagsGroupLimit; let last = last">
              <u-icon class="group-icon" *ngIf="group.icon" [model]="group.icon"></u-icon>
              <div
                data-cy="search-results-tags-item"
                #resultTagWrapper
                class="result-tag"
                *ngFor="let tag of last ? (group.tags | slice: 0 : tagsLimit) : group.tags"
              >
                <result-tag
                  #resultTag
                  *ngIf="!isAttachment(tag)"
                  [model]="tag"
                  [dragMetadata]="dragMetadata"
                  click-invoker
                  (invoke)="onMouseClick({ command: $event })"
                >
                </result-tag>
                <result-attachment
                  *ngIf="isAttachment(tag)"
                  #resultAttachment
                  [model]="tag"
                  [smallWidth]="mainWidth < 410"
                  [dragMetadata]="dragMetadata"
                  [downloadEnabled]="downloadAttachmentEnabled"
                  click-invoker
                  (invoke)="onMouseClick({ command: $event })"
                >
                </result-attachment>
                <div class="attachment-margin" [style.margin-right.px]="isAttachment(tag) ? 4 : 10"></div>
              </div>
            </div>
            <div class="tags-counter" *ngIf="counterTags">
              {{ '+' + counterTags }}
            </div>
            <result-attachment
              class="tag-group more-attachments"
              *ngIf="moreAttachments?.length"
              [moreAttachments]="moreAttachments"
              [downloadEnabled]="downloadAttachmentEnabled"
              [dragMetadata]="dragMetadata"
              click-invoker
              (invoke)="onMouseClick({ command: $event })"
            >
            </result-attachment>
          </div>
        </div>
      </div>
      <restricted-message *ngIf="restrictedLink" [ngClass]="{ hidden: !selected }"></restricted-message>
      <div
        data-cy="search-results-actions-container"
        class="buttons-container"
        [ngClass]="{ hide: !selected }"
        *ngIf="showResultSections?.showContextMenu"
      >
        <div
          *ngIf="showResultSections?.showFeedback && (showIndicateFeedbackSent || !feedbackSent)"
          class="indicate-feedback-container"
          #feedback
        >
          <div *ngIf="showIndicateFeedbackSent; else indicateFeedback" class="indicate-feedback-sent">Thank you!</div>
          <ng-template #indicateFeedback>
            <div
              class="indicate-feedback"
              pTooltip="Give Feedback"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
              (click)="onShowFeedback($event)"
            >
              <u-icon
                [styles]="{ fontSize: '12px', color: 'var(--color-text-secondary)' }"
                [model]="{ type: 'font', value: 'icon-like' }"
              ></u-icon>
              <u-icon
                [styles]="{ fontSize: '12px', color: 'var(--color-text-secondary)' }"
                [model]="{ type: 'font', value: 'icon-dis-like' }"
              ></u-icon>
            </div>
          </ng-template>
          <ng-container *ngTemplateOutlet="overlayFeedback"></ng-container>
        </div>

        <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
          <div
            class="favorite-star"
            click-invoker
            (click)="toggleFavorite('mouse_click'); $event.stopPropagation()"
            *ngIf="showResultSections.showFavoriteAction"
          >
            <u-icon
              data-cy="search-results-actions-favorite"
              pTooltip="Remove from favorites"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
              [styles]="{ color: 'var(--color-primary)', fontSize: '14px' }"
              [model]="{ type: 'font', value: 'icon-star-solid' }"
            ></u-icon>
          </div>
        </ng-container>

        <u-icon
          *ngIf="isPreviewClickAction(model?.action) && !disablePreviewIcon && showResultSections.showPreviewIcon"
          data-cy="search-results-actions-preview"
          (click)="onPreviewClick($event); $event.stopPropagation()"
          class="indicate-preview"
          [model]="INDICATE_PREVIEW_ICON"
          pTooltip="Preview"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        ></u-icon>

        <u-icon
          *ngIf="isAvailableSummary(model?.action) && showResultSections.showSummaryIcon"
          class="indicate-summary"
          (click)="onSummary($event, summaryResourceId)"
          [model]="INDICATE_SUMMARY_ICON"
          pTooltip="Show summary"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
        ></u-icon>

        <square-button
          class="context-menu"
          data-cy="search-results-actions-kebab"
          [active]="contextMenuHelper?.source === 'actions'"
          click-invoker
          (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
          (auxclick)="$event.stopPropagation(); openContextMenu($event, 'actions')"
          (contextmenu)="$event.stopPropagation(); openContextMenu($event, 'actions')"
          #actions
          >•••</square-button
        >
        <new-indication *ngIf="showResultSections?.showNewIndication" [tooltip]="showResultSections.showNewIndication"></new-indication>
      </div>
    </div>
  </div>
  <div class="blocker" *ngIf="model.deleted"></div>
  <div class="confirm" *ngIf="confirmOptions" (click)="onConfirm(null, $event)">
    <span class="message" *ngIf="confirmOptions.message !== null">{{ confirmOptions.message || 'Are you sure?' }}</span>
    <button class="cancel-btn" (click)="onConfirm(false, $event)">
      <i class="far fa-times-circle"></i>{{ confirmOptions.cancelText || 'No' }}
    </button>
    <button class="confirm-btn" (click)="onConfirm(true, $event)">
      <i class="far fa-check-circle"></i>{{ confirmOptions.confirmText || 'Yes' }}
    </button>
  </div>
</ng-container>

<ng-container *ngIf="model && model.view && layoutMode === 'gallery'">
  <gallery-view
    [model]="model"
    [settings]="{
      showPreview: isPreviewClickAction(model?.action) && !disablePreviewIcon && showResultSections.showPreviewIcon,
      showSummary: isAvailableSummary(model?.action) && showResultSections.showSummaryIcon,
      showCheckbox: showResultSections.isEditable,
      showDrag: showResultSections.isDraggable,
      showInputTitle: model?.showResultSections?.showInputTitle || showResultSections?.showInputTitle,
      showFavorite:
        model.isFavorite &&
        hubService.currentLocation !== 'favorites' &&
        !showResultSections.showFavoriteAction &&
        showResultSections.showFavoriteIcon !== false,
      showBadge: model?.showResultSections?.showBadgeGalleryView,
      showNewIndication: model?.showResultSections?.showNewIndication,
    }"
    [thumbnail]="thumbnail"
    [inputPlaceholder]="model.view.title.text"
    (invoke)="galleryInvoke($event)"
    [contextMenuActive]="contextMenuHelper?.source === 'actions'"
    [checked]="checked"
    [selected]="selected"
    [hovered]="hovered"
  >
    <ng-template let-value pTemplate="dragItem">
      <ng-content select=".drag-ind"></ng-content>
    </ng-template>
  </gallery-view>
</ng-container>

<!--Templates-->
<ng-template #resultSubtitle>
  <result-subtitle
    [class.trim-subtitle]="showResultSections.trimSubtitleLength && !showResultSections.showSubtitleInSecondLine"
    [class.subtitle-second-line]="showResultSections.showSubtitleInSecondLine"
    *ngIf="model.view.subtitle"
    [model]="model.view.subtitle"
    [highlights]="highlights"
    (contextmenu)="model.view.subtitle.onRightClick ? null : onRightClick($event, 'subtitle')"
    (auxclick)="model.view.subtitle.onRightClick ? null : onAuxClick($event, 'subtitle')"
    (click)="model.view.subtitle.onClick ? $event.stopPropagation() : null"
    (invoke)="onMouseClick($event)"
    click-invoker
    #subtitle
  >
  </result-subtitle>
</ng-template>

<ng-template #resultBadge>
  <result-badge
    *ngIf="model.view.badge"
    [model]="model.view.badge"
    (invoke)="onMouseClick({ command: $event })"
    click-invoker
  ></result-badge>
</ng-template>

<ng-template #resultFavorite>
  <div
    class="favorite"
    click-invoker
    *ngIf="
      model.isFavorite &&
      hubService.currentLocation !== 'favorites' &&
      !showResultSections.showFavoriteAction &&
      showResultSections.showFavoriteIcon !== false
    "
  >
    <u-icon [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
  </div>
</ng-template>

<ng-template #overlayFeedback>
  <p-overlayPanel #op [dismissable]="false" [styleClass]="'overlay-feedback'" (outsideClick)="onHideFeedback($event)">
    <feedback-popup
      *ngIf="isShowFeedback"
      [resourceId]="resourceId"
      [resourceName]="model?.view?.title?.text"
      [resourceAppId]="resourceAppId"
      [snippet]="model?.snippet || snippetRef?.nativeElement.innerText"
      [linkId]="linkId"
      [searchId]="searchId"
      [index]="index"
      [query]="query"
      [resourceLinkUrl]="model?.view?.title?.onClick?.url"
      (displayViewStatus)="feedbackDisplayView = $event"
      (feedbackSent)="onFeedbackSentFunc()"
      (closePopup)="onHideFeedback($event)"
    ></feedback-popup>
  </p-overlayPanel>
</ng-template>
